module.exports = __webpack_public_path__ + "media/images/icons/x-circle-6e7d077019076688bfbfb2c9b9516cf6.svg";